import { useEffect, useState } from 'react';

/**
 * Subscribes to a media query. Used for the handful of places where a
 * breakpoint has to change behaviour rather than styling, e.g. the top bar's
 * More menu carries the theme toggle only while the bar itself has hidden it.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window === 'undefined' ? false : window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = () => setMatches(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
